module.exports = __webpack_public_path__ + "media/video806.939ddab1.mp4";